import { ref, inject } from "vue";
import { useStore } from "vuex";

export default function useActionButtonsCommon() {
  const store = useStore();
  const selectedDevices = inject("selectedDevices");
  const selectedDevicesGrouped = inject("selectedDevicesByCourseName");

  const loading = ref(false);
  const _error = ref(null);

  return {
    store,
    loading,
    _error,
    selectedDevices,
    selectedDevicesGrouped,
  };
}
